import { PersonSearch } from "@mui/icons-material";
import { Button, Tooltip } from "@mui/material";

import { EntityButtonProps } from "@/types/button";
import { OpenAccountUser } from "@/types/openAccount";
import { PasswordResetUser } from "@/types/passwordReset";

import { useRecaptcha } from "@/context/util/recaptcha";

export default function QuestionButton<T extends PasswordResetUser>(
  props: EntityButtonProps<
    T,
    Pick<
      OpenAccountUser["securityQuestion"],
      "answer" | "answerConfirmation" | "id" | "label"
    >
  > & { questionDisabled?: boolean }
) {
  const { showV2 } = useRecaptcha();

  const hasErrors =
    Object.keys(props.errors).length > 0 ||
    !props.entity?.securityQuestion?.answer?.length ||
    (!props.questionDisabled &&
      !props.entity?.securityQuestion?.answerConfirmation?.length) ||
    !props.entity?.securityQuestion?.id?.length ||
    !props.entity?.securityQuestion?.label?.length;

  function getTooltip() {
    if (hasErrors) {
      return `Please complete and validate all fields ${props.tooltipSuffix}`;
    } else if (showV2) {
      return `Please complete the reCAPTCHA ${props.tooltipSuffix}`;
    }
    return `Click ${props.tooltipSuffix}`;
  }

  return (
    <Tooltip title={getTooltip()}>
      <span>
        <Button
          disabled={hasErrors || showV2}
          onClick={() => props.onClick()}
          sx={{
            height: 48,
            padding: "1em 3em",
            width: {
              xs: "100%",
              sm: "auto",
            },
          }}
          startIcon={props.startIcon ?? <PersonSearch />}
          variant="contained"
        >
          {props.label ?? "Verify"}
        </Button>
      </span>
    </Tooltip>
  );
}
